import React, { Component } from 'react'
import BudgetsApi from '../../../../api/Budgets'
import { get, isEmpty, omit, pick, set } from 'lodash'
import { message, Select } from 'antd'
import AddBudget from './AddBudget'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { compose } from 'recompose'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSort from '../../../../elements/HOC/withSort'
import { arrVal, execute, idMaker, sessionItemByKeys, strVal } from '../../../../modules/Utils'
import DocumentsApi from '../../../../api/Documents'
import withMapList from '../../../../elements/HOC/withMapList'
import { withRouter } from 'react-router-dom'

class AddBudgetCont extends Component {
  constructor(props) {
    super(props)
    this.key = get(props.match, 'params.key')
  }

  docsApi = new DocumentsApi()
  state = {
    submitting: false,
    visibleBudget: false,
    ServicesSelectCmp: Select,
    ContractsSelectCmp: Select,
    budgetsList: [],
    actions: [],
    budgetLine: {},
    budget: {},
    modalType: 'new',
    type: 'new',
    fetching: false,
    visibleAddLine: false,
  }
  api = new BudgetsApi()

  formRef = React.createRef()
  invoiceFormRef = React.createRef()
  serviceSelectRef = React.createRef()
  budgetFormRef = React.createRef()
  ids = idMaker()

  async componentDidMount() {
    if (!isEmpty(this.key)) {
      this.fetch()
      this.fetchLines()
    }
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const budget = await this.api.read(this.key)
      this.onChangeCompany(budget.company._id)
      this.onChangeClient(budget.client._id)
      this.onChangeContract(budget.contract._id)
      const actions = await this.docsApi.actions('budgets', budget.status)
      this.setState({
        type: 'edit',
        budget,
        actions,
        fetching: false,
      })
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  fetchLines = async () => {
    this.setState({
      fetchingLines: true,
    })
    const lines = await this.api.lines.list(this.key)
    this.setState({
      budgetsList: lines,
      fetchingLines: false,
    })
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.setState({
            budget: Object.assign({}, this.state.budget, values),
          })
          res(true)
        }
      })
    })
  }
  checkBudgetForm = () => {
    return new Promise((res, rej) => {
      this.budgetFormRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(Object.assign({}, this.state.budgetLine, values))
        }
      })
    })
  }
  removeBudget = async key => {
    if (this.state.type === 'new') {
      let newData = [...this.state.budgetsList]
      newData = newData.filter(item => key !== item.key)
      this.setState({ budgetsList: newData })
      this.onCancelBudget()
    } else {
      try {
        const budget = this.state.budgetsList.find(b => b._id === key)
        this.setState({
          removingBudget: true,
        })
        await this.api.lines.remove(pick(budget, ['_key', '_id', '_rev']))
        this.setState({
          removingBudget: false,
        })
        this.onCancelBudget()
        await this.fetchLines()
      } catch (e) {
        this.setState({
          removingBudget: false,
        })
        message.error(e.errorMessage)
      }
    }
  }

  submit = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      const { budgetsList } = this.state
      if (budgetsList.length < 1) {
        message.error('No Budgets Found')
        return
      }
      await this.api.createWithLines({
        budget: this.state.budget,
        lines: budgetsList.map(b => omit(b, ['key'])),
      })
      this.setState({
        submitting: false,
      })
      this.props.history.push({
        pathname: `/corporates/budgets/`,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  invoiceBudget = async () => {
    try {
      this.setState({
        invoicing: true,
      })
      let { billLines } = this.state
      billLines = billLines.map(b => {
        b.unit = b.invoiced
        return pick(b, ['unit', '_id', '_rev'])
      })

      if (billLines.length < 1) {
        message.error('No Budgets Found')
        return
      }
      await this.api.invoiceBudget({
        key: this.state.budget._key,
        lines: billLines,
      })
      this.setState({
        invoicing: false,
      })
      this.onCancelInvoice()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ invoicing: false })
    }
  }
  onShowBudget = () => {
    this.setState({
      visibleBudget: true,
      budgetLine: {},
      modalType: 'new',
    })
  }
  onShowInvoice = () => {
    this.setState(prvState => ({
      visibleInvoice: true,
      invoice: {},
      billLines: prvState.budgetsList.map(b => ({ ...b, invoiced: b.unit })),
    }))
  }
  onShowEditBudget = (e, budgetLine) => {
    this.setState({
      visibleBudget: true,
      budgetLine,
      modalType: 'edit',
    })
  }
  onChangeInvoicePercentage = percentage => {
    this.setState(prvState => {
      return {
        billLines: prvState.billLines.map(b => {
          const invoiced = b.unit * (percentage / 100)
          let nt = Math.round(invoiced * b.rate * 100) / 100
          let tx = Math.round(invoiced * b.tax.rate * 100) / 100
          const gross = Math.round((tx + nt) * 100) / 100
          const amount = { net: nt, tax: tx, gross }
          return { ...b, invoiced, amount }
        }),
      }
    })
  }
  onEditBudget = async () => {
    const values = await this.checkBudgetForm()
    if (this.state.type === 'new') {
      const { budgetsList } = { ...this.state }
      let budget = budgetsList.findIndex(b => b.key === values.key)
      budgetsList.splice(budget, 1, values)
      const newBudgetList = [...budgetsList]
      this.setState({ budgetsList: newBudgetList, visibleBudget: false })
    } else {
      try {
        this.setState({
          updatingBudget: true,
        })
        await this.api.lines.update(
          omit(values, ['budget', 'contract', 'invoiced', 'amount', 'type', 'delivery']),
        )
        this.setState({
          updatingBudget: false,
        })
        this.onCancelBudget()
        await this.fetch()
        await this.fetchLines()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          updatingBudget: false,
        })
      }
    }
  }
  onCancelBudget = () => {
    this.setState({
      visibleBudget: false,
    })
  }
  onCancelInvoice = () => {
    this.setState({
      visibleInvoice: false,
    })
  }
  onAddBudget = async () => {
    const values = await this.checkBudgetForm()
    if (this.state.type === 'new') {
      const { budgetsList } = { ...this.state }
      values.key = this.ids.next().value
      values.budget = { _id: 'temp' }
      const newBudget = [...budgetsList, values]
      this.setState({ budgetsList: newBudget, visibleBudget: false })
    } else {
      try {
        this.setState({
          updatingBudget: true,
        })
        values.contract = this.state.budget.contract
        values.budget = pick(this.state.budget, ['_id', '_rev', 'code'])
        // get(values, 'pickup.time') && set(values, 'pickup.time', moment(get(values, 'pickup.time')).format('HH:mm'))
        // get(values, 'pickup.date') && set(values, 'pickup.date', moment(get(values, 'pickup.date')).format('YYYY-MM-DD'))
        await this.api.lines.add(values)
        this.setState({
          updatingBudget: false,
        })
        this.onCancelBudget()
        await this.fetchLines()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          updatingBudget: false,
        })
      }
    }
  }
  onChangeCompany = company => {
    const url = `products/` + `?owner=${company}&state=Active` + '&select=*'
    this.url = url
    const ProductsSelect = compose(
      withUrlFetch({
        name: 'products',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort,
    )(CustomSelect)

    this.formRef.current.resetFields(['client._id', 'contract._id'])
    this.setState({ company, productsURL: url, ProductsSelect })
  }
  onChangeClient = client => {
    this.formRef.current.resetFields(['contract._id'])
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const { company } = this.state
      const url =
        `clients/` +
        (isEmpty(owner) ? '' : `${owner}`) +
        `/contracts?company=${company}&state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort,
      )(CustomSelect)
      this.setState({ client, ContractsSelectCmp })
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }
  onChangeContract = contract => {
    if (!isEmpty(contract)) {
      const ServicesSelectCmp = compose(
        withUrlFetch({
          name: 'clients',
          url: contract,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSubDropdown({ name: 'rates' }),
        withMapList(({ name, ...r }) => ({
          name: `${strVal(r, 'product.name')} / ${name}`,
          ...r,
        })),
        withSort,
      )(CustomSelect)
      this.setState({ contract, ServicesSelectCmp })
    } else {
      this.setState({
        ServicesSelectCmp: Select,
      })
    }
  }
  onChangeBudgetUOM = uom => {
    const data = arrVal(
      {
        data: sessionItemByKeys(
          `products_${this.state.productsURL}_dropdown`,
          this.budgetFormRef.current.getFieldValue('product._id'),
          '_id',
          'price',
        ),
      },
      'data',
    )
    const uomlist = data.find(u => u.uom.key === uom)
    this.budgetFormRef.current.setFieldsValue({
      'tax.rate': get(uomlist, 'tax.value'),
      rate: get(uomlist, 'price'),
      'tax.type': get(uomlist, 'tax.type'),
      name: get(uomlist, 'uom.name'),
      unit: undefined,
    })
  }
  handleOps = async (operation, budget) => {
    const { remove } = this.api
    const { history } = this.props
    switch (operation) {
      case 'confirm':
        await execute(
          this,
          this.api.operation.bind(this, 'confirm', pick(budget, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'cancel':
        await execute(
          this,
          this.api.operation.bind(this, 'cancel', pick(budget, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'revise':
        await execute(
          this,
          this.api.operation.bind(this, 'revise', pick(budget, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'remove':
        try {
          await execute(this, remove.bind(this, pick(budget, ['_key', '_rev', '_id'])), message)
          history.replace({
            pathname: `/corporates/budgets/`,
          })
        } catch (e) {}
        break
      case 'close':
        await execute(
          this,
          this.api.operation.bind(this, 'close', pick(budget, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
    }
  }
  onChangeCost = (field, value) => {
    this.setState({
      visibleAddLine: true,
      budgetsCost: value,
    })
  }
  render() {
    return (
      <AddBudget
        {...this.state}
        {...pick(this, [
          'fetchLines',
          'submit',
          'invoiceBudget',
          'fetch',
          'handleOps',
          'onShowBudget',
          'onShowInvoice',
          'onCancelInvoice',
          'onEditBudget',
          'onShowEditBudget',
          'onCancelBudget',
          'removeBudget',
          'onAddBudget',
          'onChangeCompany',
          'onChangeContract',
          'onChangeClient',
          'onChangeBudgetUOM',
          'onChangeInvoicePercentage',
          'getBudget',
          'formRef',
          'budgetFormRef',
          'serviceSelectRef',
          'invoiceFormRef',
          'onChangeCost',
        ])}
      />
    )
  }
}

AddBudgetCont.propTypes = {}
AddBudgetCont.defaultProps = {}

export default compose(withRouter)(AddBudgetCont)
